up.compiler('[open-on-visit-dialog]', (element, { size }) => {
  const content = element.innerHTML

  up.layer.open({
    content,
    size: size ?? 'medium',
  })
})
